
import {
  defineComponent,
  ref,
  toRef,
  getCurrentInstance,
  onMounted,
  PropType,
} from "vue";
import QRCode from "qrcode";

import ApiService from "@/core/services/ApiService";
import { MenuComponent } from "@/assets/ts/components";
// import AddChargebackResponseDrawer from "@/layout/extras/AddChargebackResponseDrawer.vue";
// import ViewChargebackResponseDrawer from "@/layout/extras/ViewChargebackResponseDrawer.vue";
import { ElMessage } from "element-plus";
interface Connection {
  id: string;
  conn_name: string;
  scheme: string;
  host: string;
  domain: string;
  auth_type: string;
  payload_type: string;
  response_type: string;
  enabled: string;
  conn_status: string;
  category: string;
  created: string;
  modified: string;
  logo_url: string;
}

export default defineComponent({
  name: "chargeback-actions",
  components: {
    // AddChargebackResponseDrawer,
    // ViewChargebackResponseDrawer,
  },
  props: {
    incomingData: { type: Object, required: true },
    apiSyncItems: Array,
    connections: { type: Array as PropType<Array<Connection>> },
  },
  emits: ["reload-incoming", "open-drawer", "trigger-action", "form-entry"],
  setup(props, { emit }) {
    const createResponseBtn = ref<HTMLButtonElement | null>(null);
    const openResponseDrawerBtn = ref<HTMLButtonElement | null>(null);
    const generateQRBtn = ref<HTMLButtonElement | null>(null);
    const sendResponseBtn = ref<HTMLButtonElement | null>(null);
    // eslint-disable-next-line
    const $vueInstance: any = getCurrentInstance();
    const incoming = toRef(props, "incomingData");

    const onOpenResponseDrawer = () => {
      emit("open-drawer");
    };

    const onGenerateQR = async () => {
      const img = await QRCode.toDataURL(incoming.value.dispute_url);
      console.log(incoming.value.dispute_url);
      console.log(img);
    };

    const onFormEntry = async () => {
      emit("form-entry");
    };

    const reInitializeMenus = () => {
      setTimeout(() => {
        MenuComponent.reinitialization();
      }, 0);
    };

    onMounted(() => {
      reInitializeMenus();
    });

    const getConnName = (conn_id) => {
      const conn = props.connections?.find((ele) => ele.id === conn_id);
      if (conn) {
        return conn.conn_name;
      }

      return "";
    };

    const findTransaction = async (item) => {
      emit("trigger-action", true);
      try {
        const res = await ApiService.put(
          `chargebacks/incoming/${incoming.value.id}?action=find_transaction&id=${item.id}`,
          {}
        );
        if (res.data.success) {
          emit("reload-incoming");
          ElMessage({
            message: "Transaction Found!",
            type: "success",
          });
        } else {
          ElMessage({
            message: "Cannot Find Transaction",
            type: "warning",
          });
        }
      } catch (e) {
          ElMessage.error('Oops, something happened.');

      }
      emit("trigger-action", false);
    };

    const onCreateResponse = async () => {
      emit("trigger-action", true);
      try {
        await ApiService.put(
          `chargebacks/incoming/${incoming.value.id}?action=response_packet&reason_condition=${incoming.value.reason_condition}`,
          {}
        );
        emit("reload-incoming");
          ElMessage({
            message: "Response Created!",
            type: "success",
          });
      } catch (e) {
          ElMessage.error('Oops, something happened.');
      }

      emit("trigger-action", false);
    };

    const sendResponse = async () => {
      emit("trigger-action", true);

      // eslint-disable-next-line
      sendResponseBtn.value!.disabled = true;
      // Activate indicator
      sendResponseBtn.value?.setAttribute("data-kt-indicator", "on");

      try {
        const res = await ApiService.put(
          `chargebacks/incoming/${incoming.value.id}?action=send_response`,
          {}
        );
        if (res.data.success) {
          emit("reload-incoming");
          ElMessage({
            message: "Response Successfully Sent!",
            type: "success",
          });
        } else {
          ElMessage({
            message: "Could not send.",
            type: "success",
          });
        }
      } catch (e) {
          ElMessage.error('Oops, something happened.');

      }
      // eslint-disable-next-line
      sendResponseBtn.value!.disabled = true;
      // Activate indicator
      sendResponseBtn.value?.setAttribute("data-kt-indicator", "on");

      emit("trigger-action", false);
    };

    const resetBtn = ref<null | HTMLButtonElement>(null);

    const onReset = async () => {
      emit("trigger-action", true);

      try {
        const res = await ApiService.put(
          `chargebacks/incoming/${incoming.value.id}?action=reset`,
          {}
        );
        if (res.data.success) {
          emit("reload-incoming");
          ElMessage({
            message: "Chargeback Details Reset!",
            type: "success",
          });
        } else {
          ElMessage.error('Oops, something happened.');
        }
      } catch (e) {
          ElMessage.error('Oops, something happened.');

      }
      emit("trigger-action", false);
    };

    return {
      openResponseDrawerBtn,
      generateQRBtn,
      createResponseBtn,
      findTransaction,
      onCreateResponse,
      sendResponse,
      sendResponseBtn,
      onOpenResponseDrawer,
      onGenerateQR,
      onFormEntry,
      incoming,
      resetBtn,
      onReset,
      getConnName,
    };
  },
});
